import { render } from "./MyPassesOld.vue?vue&type=template&id=3c503c2e"
import script from "./MyPassesOld.vue?vue&type=script&lang=js"
export * from "./MyPassesOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__